import { readableCode } from "@/features/credits/journals";

const effectKindLabels: Record<string, string> = {
  purchased_credits: "Credit purchase",
  subscription_grant: "Subscription credits",
  refund_removal: "Refund",
  failed_payment_removal: "Removed after failed payment",
  chargeback_removal: "Chargeback",
  signup_grant: "Signup bonus",
  opening_balance: "Opening balance",
  credit_refresh: "Credit refresh",
  compensation_grant: "Compensation",
  other_reward: "Reward",
  closure_removal: "Account closed",
  support_grant: "Support grant",
  support_removal: "Support removal",
  correction: "Correction",
  hold_settlement: "Hold settlement",
  creator_reward_deposit: "Creator reward deposit",
};

const sourceSystemLabels: Record<string, string> = {
  stripe: "Stripe",
  app_store: "App Store",
  migration: "Migration",
  product_api: "Pax API",
  support: "Support",
  model_gateway: "Model gateway",
};

/** What a whole operation was, from the ledger's `effect_kind`. */
export function effectKindLabel(effectKind: string): string {
  return effectKindLabels[effectKind] ?? readableCode(effectKind);
}

/** The system that asked for an operation. */
export function sourceSystemLabel(sourceSystem: string): string {
  return sourceSystemLabels[sourceSystem] ?? readableCode(sourceSystem);
}
